import WADAClassificationService from '../../services/WADAClassificationService';

export default {
    state: {
        collection: [],
    },
    getters: {
        getAllWADA: store => store.collection,
        getSingleWADA: store => (id) => {
            const items = store.collection.filter(wada => wada.id === id);

            return items.length > 0 ? items[0] : {};
        },
    },
    mutations: {
        loadWADA(state, payload) {
            state.collection = payload;
        },
    },
    actions: {
        async loadWADA(context) {
            try {
                const payload = await WADAClassificationService.getAll();
                context.commit('loadWADA', payload);
                return payload;
            } catch (error) {
                throw Error(error.message);
            }
        },
    },
    namespaced: true,
};
